import React, {
  useEffect,
  useState,
  useLayoutEffect,
  createContext,
  useRef,
} from 'react';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { UNIT_TYPE, USER_ROLES } from 'constants/constants';
import useI18n from 'hooks/use-i18n';
import CourseInfo from 'modules/Course/Unit/components/CourseInfo';
import Content from 'modules/Course/Unit/components/Content/Content';
import ContentLTI from 'modules/Course/Unit/components/Content/ContentLTI';
import ContentTest from 'modules/Course/Unit/components/ContentTest/ContentTest';
import ContentSurvey from 'modules/Course/Unit/components/ContentSurvey/ContentSurvey';
import ContentCalendar from 'modules/Course/Unit/components/ContentCalendar/ContentCalendar';
import ContentScorm from 'modules/Course/Unit/components/ContentScorm/ContentScorm';
import styles from '../../../../styles/Messages.module.scss';
import {
  useFetchUnits,
  useFetchUnit,
  useUnit,
  useUnits,
  useUnitsError,
  useTest,
} from 'hooks/units/index';
import { useDispatch, useSelector } from 'react-redux';
import { refreshUnitAsync, setUnitsError } from 'store/units';
import ErrorPage from 'components/ErrorPage/ErrorPage';
import { useCourse } from 'hooks/course';
import Loading from 'components/Layout/Loading';
import classNames from 'classnames';
import BreadCrumbsPage from 'components/Breadcrumb/Breadcrumb';
import { getCourseAsync } from 'store/course';
import { isMobile } from 'react-device-detect';
import { Edit2 } from 'react-feather';
import { getViewMode } from 'store/auth';
import Router, { useRouter } from 'next/router';
import { useUser } from 'hooks';
import getMonitorUrl from 'helpers/monitoring';
import { getColor, getColorText } from 'store/settings';
import { titleExtensionWithTimeZone } from 'helpers/format-time';
import { MdFullscreen, MdFullscreenExit } from 'react-icons/md';
import { element, elementType } from 'prop-types';
import { getSelectedCentre } from 'store/master';
import { toast } from 'react-toastify';
import { showToastError } from '@core/components/toastify/ToastTypes';
import QuestionInfo from 'modules/Course/Unit/components/QuestionInfo';
import unitCourseApi from 'api/unitCourseApi';
import debounce from 'lodash/debounce';

export const UnitIdContext = createContext({});
const UnitPage = () => {
  const {
    query: { unitId, lessonType },
  } = useRouter();

  const unitSelected = useUnit();

  const test = useTest();

  const [bookmarked, setBookmarked] = useState(unitSelected?.bookMark ?? {});

  const [quizPosition, setQuizPosition] = useState([]);
  const [availablePosition, setAvailablePosition] = useState([]);
  const [startQuestionIndex, setStartQuestionIndex] = useState();
  const [durationDisable, setDurationDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSync, setIsSync] = useState(false);
  const grandchildRef = useRef(null);
  const selectedCentre = useSelector(getSelectedCentre);
  const { router, asPath } = useRouter();
  const viewMode = useSelector(getViewMode);
  const courseId = router?.query?.slug;

  const screen1 = useFullScreenHandle();
  const dispatch = useDispatch();
  const param = {
    reviewContent: !selectedCentre ? true : selectedCentre?.reviewContent,
  };

  if (selectedCentre?._id) {
    param.centreId = selectedCentre?._id;
  }
  const i18n = useI18n();
  const user = useUser();
  const units = useUnits();
  const course = useCourse();
  const unitsError = useUnitsError();
  const [display, setDisplay] = useState(
    lessonType ? 'unit-page-display-none' : 'unit-page-display',
  );
  const [fullScreen, setFullScreen] = useState(lessonType ? 12 : 9);
  const [checkFullScreen, setCheckFullScreen] = useState(false);
  const [iconDisplay, setIconDisplay] = useState(lessonType ? true : false);
  const [dynamicBreadCrumb, setDynamicBreadCrumb] = useState([]);
  const [importTitle, setImportTitle] = useState('');
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  useFetchUnits(param);
  useFetchUnit();

  const courseNameDisplay = () => {
    if (course) {
      if (course?.name.includes(course?.code)) {
        return course?.name;
      } else {
        return course?.name + ' (' + course?.code + ')';
      }
    }
  };

  const breadcrumb = [
    {
      text: i18n.t('dashboard'),
      link: '/',
    },
    {
      text: courseNameDisplay(),
      link: `/course/${course?._id}`,
    },
    {
      text: `${
        unitSelected?.type == UNIT_TYPE.LIVESTREAMING &&
        unitSelected?.titleExtenstion
          ? unitSelected?.title +
            ' ' +
            titleExtensionWithTimeZone(
              unitSelected?.time?.begin,
              unitSelected?.time?.end,
              unitSelected?.timezone,
            )
          : unitSelected?.type == UNIT_TYPE.LIVESTREAMING &&
            unitSelected?.importLesson === true
          ? importTitle
          : unitSelected?.title
      }`,
      active: true,
    },
  ];

  useEffect(() => {
    if (viewMode === 'LEARNER' && user?._id) {
      getMonitorUrl(user, viewMode, asPath);
    }
  }, [viewMode, user]);

  //edit
  const ROUTE_EDIT = {
    SURVEY: `/course/${unitSelected?.course}/edit-survey?id=${unitSelected?._id}`,
    TEST: `/course/${unitSelected?.course}/edit-test?id=${unitSelected?._id}`,
    ASSIGNMENT: `/unit/${unitSelected?._id}/edit`,
    DISCUSSION: `/course/${unitSelected?.course}/discussion/${unitSelected?._id}/edit`,
    CLASSROOM: `/course/${unitSelected?.course}/add-classroom/${unitSelected?._id}?isEdit=true`,
    LIVESTREAMING: `/course/${unitSelected?.course}/add-live-training/${unitSelected?._id}?isEdit=true`,
    MSTEAMS_MEETING: `/course/${unitSelected?.course}/add-msteams-meeting/${unitSelected?._id}?isEdit=true`,
  };

  const handleRouteEdit = () => {
    if (
      unitSelected?.events?.length === 1 &&
      unitSelected?.type === UNIT_TYPE.LIVESTREAMING
    ) {
      Router.push(
        `/course/${unitSelected?.course}/add-live-training?id=${unitSelected?._id}&isEdit=true`,
      );
    } else if (
      unitSelected?.events?.length === 1 &&
      unitSelected?.type === UNIT_TYPE.MSTEAMS_MEETING
    ) {
      Router.push(
        `/course/${unitSelected?.course}/add-msteams-meeting?id=${unitSelected?._id}&isEdit=true`,
      );
    } else {
      Router.push(
        ROUTE_EDIT?.[unitSelected?.type] || `/unit/${unitSelected?._id}/edit`,
      );
    }
  };

  const nth = (getdate) => {
    if (getdate > 3 && getdate < 21) return 'th';
    switch (getdate % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const dateConversion = (startdate) => {
    var date_time = new Date(startdate);
    let dayOfWeekNumber = date_time.getDay();
    let getdate = date_time.getDate();
    let nameOfDay;
    var month = date_time.toLocaleString('default', { month: 'long' });

    switch (dayOfWeekNumber) {
      case 0:
        nameOfDay = 'Sunday';

        break;
      case 1:
        nameOfDay = 'Monday';

        break;
      case 2:
        nameOfDay = 'Tuesday';

        break;
      case 3:
        nameOfDay = 'Wednesday';

        break;
      case 4:
        nameOfDay = 'Thursday';

        break;
      case 5:
        nameOfDay = 'Friday';

        break;
      case 6:
        nameOfDay = 'Saturday';

        break;
    }

    var hours = date_time.getHours();
    var minutes = date_time.getMinutes();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = `${hours}:${minutes}${ampm}`;
    let date_conversation = {
      nameOfDay: nameOfDay,
      getdate: getdate,
      nth: nth(getdate),
      month: month,
      strTime: strTime,
    };

    return date_conversation;
  };

  useEffect(() => {
    if (unitSelected?.course) {
      let params = {};
      if (selectedCentre?._id) {
        params.courseCentre = selectedCentre?._id;
      }
      if (selectedCentre?.reviewContent) {
        params.reviewContent = selectedCentre?.reviewContent;
      }

      dispatch(getCourseAsync(unitSelected?.course, params));
    }
  }, [unitSelected, selectedCentre]);

  useEffect(() => {
    if (!test?.unitQuestion) {
      setBookmarked({});
      let localunitId =
        localStorage.getItem('unitId') !== null &&
        localStorage.getItem('unitId') !== undefined &&
        localStorage.getItem('unitId') !== ''
          ? localStorage.getItem('unitId')
          : undefined;

      if (localunitId) {
        if (localunitId !== unitId) {
          localStorage.removeItem('unitId');
          localStorage.removeItem('testStartTime');
          sessionStorage.removeItem('testSeconds');
        }
      }
    }
  }, [test]);

  useEffect(() => {
    if (
      unitSelected?.type == 'LIVESTREAMING' ||
      unitSelected?.type == 'MSTEAMS_MEETING'
        ? unitSelected?.events?.length
        : false
    ) {
      const timeStart = new Date(unitSelected.time?.begin);
      const timeEnd = new Date(unitSelected.time?.end);
      var time_Start = dateConversion(timeStart);
      var time_End = dateConversion(timeEnd);
      if (
        unitSelected.importLesson === true &&
        (unitSelected?.type === UNIT_TYPE.LIVESTREAMING ||
          unitSelected?.type === UNIT_TYPE.MSTEAMS_MEETING)
      ) {
        let title = `${unitSelected.title} (${unitSelected?.events[0]?.unit?.course?.code})  ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.nameOfDay} ${time_End.getdate}${time_End.nth} ${time_End.month} ${time_End.strTime}`;
        setImportTitle(title);
      }
    } else if (
      (unitSelected?.type == 'LIVESTREAMING' ||
        unitSelected?.type == 'MSTEAMS_MEETING') &&
      unitSelected?.isUserEvent !== false
    ) {
      // dispatch(refreshUnitAsync(unitId));
    }
  }, [unitSelected]);

  useEffect(() => {
    let breadCrumbLocal =
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('breadCrumb') !== null &&
      sessionStorage.getItem('breadCrumb') !== ''
        ? JSON.parse(sessionStorage.getItem('breadCrumb'))
        : [];
    if (breadCrumbLocal?.length && unitSelected) {
      breadCrumbLocal.map((element, i) => {
        if (element.active === true) {
          delete element.active;
          element.link = element.customLink;
        }
        if (element.val === 'unitType' || element.val === 'lessontype') {
          breadCrumbLocal.splice(i);
        }
      });
      let obj = {
        text: `${
          (unitSelected?.type == UNIT_TYPE.LIVESTREAMING ||
            unitSelected?.type == UNIT_TYPE.MSTEAMS_MEETING) &&
          unitSelected?.titleExtenstion
            ? unitSelected?.title +
              ' ' +
              titleExtensionWithTimeZone(
                unitSelected?.time?.begin,
                unitSelected?.time?.end,
                unitSelected?.timezone,
              )
            : (unitSelected?.type == UNIT_TYPE.LIVESTREAMING ||
                unitSelected?.type == UNIT_TYPE.MSTEAMS_MEETING) &&
              unitSelected?.importLesson === true
            ? importTitle
            : unitSelected?.title
        }`,
        val: 'unitType',
        customLink: `/course/${course?._id}/unit/${unitSelected?._id}`,
        active: true,
      };
      breadCrumbLocal.push(obj);
      setDynamicBreadCrumb(breadCrumbLocal);
      sessionStorage.setItem('breadCrumb', JSON.stringify(breadCrumbLocal));
    } else if (!breadCrumbLocal?.length && unitSelected && course?.name) {
      breadCrumbLocal = [
        {
          text: 'Dashboard',
          link: '/',
          val: 'dashboard',
        },
        {
          text: course?.parent ? 'Classes' : 'Courses',
          customLink: course?.parent
            ? '/intakes/intake-grid'
            : '/course/courseGrid',
          val: course?.parent ? 'intake-grid' : 'courseGrid',
          link: course?.parent ? '/intakes/intake-grid' : '/course/courseGrid',
        },
        {
          text: course?.name.includes(course?.code)
            ? course?.name
            : course?.name + ' (' + course?.code + ')',
          customLink: `/course/${course?._id}`,
          link: `/course/${course?._id}`,
          val: course?.parent ? 'intakeDetail' : 'courseDetail',
        },
        {
          text: `${
            unitSelected?.type == UNIT_TYPE.LIVESTREAMING &&
            unitSelected?.titleExtenstion
              ? unitSelected?.title +
                ' ' +
                titleExtensionWithTimeZone(
                  unitSelected?.time?.begin,
                  unitSelected?.time?.end,
                  unitSelected?.timezone,
                )
              : unitSelected?.type == UNIT_TYPE.LIVESTREAMING &&
                unitSelected?.importLesson === true
              ? importTitle
              : unitSelected?.title
          }`,
          val: 'unitType',
          customLink: `/course/${course?._id}/unit/${unitSelected?._id}`,
          active: true,
        },
      ];
      setDynamicBreadCrumb(breadCrumbLocal);
      sessionStorage.setItem('breadCrumb', JSON.stringify(breadCrumbLocal));
    }
  }, [course, unitSelected]);

  const displayRight = () => {
    setIconDisplay(!iconDisplay);
    if (display === 'unit-page-display-none') {
      setDisplay('unit-page-display');
      setFullScreen(9);
    } else {
      setDisplay('unit-page-display-none');
      setFullScreen(12);
    }
  };

  const fullScreenEnter = () => {
    checkFullScreen ? screen1.exit() : screen1.enter();
    setCheckFullScreen((preVal) => !preVal);
  };

  useEffect(
    () => () => {
      dispatch(setUnitsError(undefined));
    },
    [],
  );
  useLayoutEffect(() => {
    if (process.env.NEXT_PUBLIC_DOMAIN_HOST !== 'http://localhost:3100/') {
      const handleKeyDown = (e) => {
        if (
          e.key === 'F12' &&
          (course?.rulesAndPath?._id ? course?.rulesAndPath?.f12 : true)
        ) {
          e.preventDefault();
        }

        if (
          e.ctrlKey &&
          (course?.rulesAndPath?._id ? course?.rulesAndPath?.ctrlKey : true)
        ) {
          e.preventDefault();
        }
      };

      const handleContextMenu = (event) => {
        if (
          course?.rulesAndPath?._id ? course?.rulesAndPath?.rigthClick : true
        ) {
          event.preventDefault();
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('contextmenu', handleContextMenu);

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('contextmenu', handleContextMenu);
      };
    }
  }, [course]);

  if (unitsError !== undefined) {
    showToastError('No information found(403)');
    Router.push('/');
    // return <ErrorPage error={unitsError} />;
  }

  if (!unitSelected || !units) {
    return <Loading />;
  }

  const callGrandchildFunction = (id) => {
    let config = { questionNumber: id, isRandom: true };
    if (grandchildRef.current) {
      grandchildRef.current.grandchildFunction(config);
    }
  };

  const syncBookmarks = debounce(async (data) => {
    try {
      await unitCourseApi.updateUnitBookmark(
        {
          id: unitSelected?._id,
        },
        {
          data,
        },
      );
    } catch (err) {
      showToastError(`Failed to sync bookmarks`);
    }
  }, 500);

  const toggleBookmark = async (id) => {
    let updateObj = {
      ...bookmarked,
      [id]: !bookmarked[id],
    };

    setBookmarked(updateObj);
    syncBookmarks(updateObj);
  };

  const quizState = {
    toggleBookmark,
    bookmarked,
    setBookmarked,
    quizPosition,
    setQuizPosition,
    availablePosition,
    setAvailablePosition,
    startQuestionIndex,
    setStartQuestionIndex,
    setDurationDisable,
    durationDisable,
    iconDisplay,
    isLoading,
    setIsLoading,
    setIsSync,
    isSync,
  };

  const renderContent = (type) => {
    if (type === UNIT_TYPE.TEST) {
      return (
        <ContentTest
          ref={grandchildRef}
          quizState={quizState}
          displayRight={displayRight}
          //key={Date.now().toString()}
        />
      );
    }

    if (type === UNIT_TYPE.SURVEY) {
      return <ContentSurvey />;
    }

    if (
      type === UNIT_TYPE.CLASSROOM ||
      type === UNIT_TYPE.LIVESTREAMING ||
      type === UNIT_TYPE.MSTEAMS_MEETING
    ) {
      return <ContentCalendar />;
    }

    if (type === UNIT_TYPE.SCORM) {
      return <ContentScorm fullScreens={checkFullScreen} />;
    }

    if (type === UNIT_TYPE.LTI) {
      return <ContentLTI />;
    }

    if (type === UNIT_TYPE.DISCUSSION) {
      Router.replace(
        `/course/${unitSelected?.course}/unit/discussion?unitId=${unitSelected?._id}`,
      );
      return <Loading />;
    }

    return (
      <Content fullScreens={checkFullScreen} types={type} course={course} />
    );
  };

  return (
    <div id="screenshot-area">
      <div className="d-flex align-center flex-nowrap">
        <section className="flex-1">
          <BreadCrumbsPage
            data={dynamicBreadCrumb?.length ? dynamicBreadCrumb : breadcrumb}
          />
        </section>
        <section>
          {(unitSelected?.isCombinedClass == true
            ? unitSelected?.isCombinedClassParent !== false
            : true) &&
            viewMode !== USER_ROLES.LEARNER &&
            viewMode !== USER_ROLES.CENTRE_ADMIN && (
              <div className="mr-1">
                <Edit2
                  style={{ color: '#8E96AA' }}
                  id="edit"
                  className="cursor-pointer"
                  onClick={handleRouteEdit}
                />
                <UncontrolledTooltip target="edit">Edit</UncontrolledTooltip>
              </div>
            )}
        </section>
        <section>
          {!screen1?.active && !isMobile && (
            <div>
              <button
                data-padding="true"
                onClick={fullScreenEnter}
                id="screen"
                style={{
                  '--btn-bg-clr': colorStatus,
                  '--text-clr': colorTextStatus,
                  '--dynamic-padding': '5px',
                }}
                className="btn dynamic-btn-clr"
              >
                <MdFullscreen size={18} />

                <UncontrolledTooltip target="screen">
                  Full Screen
                </UncontrolledTooltip>
              </button>
            </div>
          )}
        </section>
      </div>
      <UnitIdContext.Provider value={screen1}>
        <div className="lesson-view-height">
          <Row noGutters>
            <Col className={`px-md-3 px-0 ${iconDisplay ? 'col' : 'col-md-9'}`}>
              <FullScreen
                handle={screen1}
                className={classNames('full__Screen1', styles['full__Screen1'])}
              >
                {screen1?.active && (
                  <div className="d-flex justify-content-end p-1">
                    <button
                      data-padding="true"
                      id="exitScreen"
                      onClick={fullScreenEnter}
                      style={{
                        '--btn-bg-clr': colorStatus,
                        '--text-clr': colorTextStatus,
                        '--dynamic-padding': '5px',
                      }}
                      className="btn dynamic-btn-clr"
                    >
                      <MdFullscreenExit size={18} />
                    </button>
                    <UncontrolledTooltip target="exitScreen">
                      Exit Full Screen
                    </UncontrolledTooltip>
                  </div>
                )}
                {unitSelected?.type && renderContent(unitSelected.type)}
              </FullScreen>
              <div
                className={classNames(
                  `pin-icon view-page-rightSide-color ${
                    iconDisplay ? 'd-md-block d-none' : 'd-none'
                  }`,
                  styles['pin-icon'],
                )}
              >
                <i
                  class="fa fa-thumb-tack"
                  aria-hidden="true"
                  onClick={displayRight}
                ></i>
              </div>
            </Col>
            <Col
              md={3}
              className={iconDisplay ? 'd-md-none' : ''}
              style={{
                position: 'relative',
              }}
            >
              <div
                className={classNames(
                  'pin-icon-1 view-page-rightSide-color d-md-block d-none',
                  `${iconDisplay ? 'display-icon-none' : 'display-icon'}`,

                  styles['pin-icon-1'],
                  styles[
                    `${iconDisplay ? 'display-icon-none' : 'display-icon'}`
                  ],
                )}
                style={{ color: '#8E96AA' }}
              >
                <i
                  class="fa fa-thumb-tack"
                  aria-hidden="true"
                  onClick={displayRight}
                ></i>
              </div>
              <div className={`${iconDisplay && 'd-md-none'}`}>
                {test?.unitQuestion ? (
                  <QuestionInfo
                    totalQuesttion={
                      unitSelected?.reAttempt
                        ? unitSelected?.totalFaiedQuestions
                        : unitSelected?.totalQuesiton || 0
                    }
                    current={test?.current}
                    callGrandchildFunction={callGrandchildFunction}
                    toggleBookmark={toggleBookmark}
                    setBookmarked={setBookmarked}
                    bookmarked={bookmarked}
                    quizPosition={quizPosition}
                    availablePosition={availablePosition}
                    durationDisable={durationDisable}
                    isLoading={isLoading || isSync}
                  />
                ) : (
                  <CourseInfo />
                )}{' '}
              </div>
            </Col>
          </Row>
        </div>
      </UnitIdContext.Provider>
    </div>
  );
};

export default UnitPage;
